const Index = () => import('./index.vue');
const CreatePage = () => import('./_pages/create.vue');
const ViewPage = () => import('./_pages/view.vue');

export default [
    {
        path: '/industries',
        name: 'IndustriesPage',
        component: Index
    },
    {
        path: '/new-industry',
        name: 'NewIndustryPage',
        component: CreatePage
    },
    {
        path: '/industry/:id',
        component: ViewPage
    }
]